/**
 * Model definition for headline
 */
export interface InternHeadline {
  __component: 'intern.headline';
  id: string;
  text?: string;
  component: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
}

export function isInternHeadline(obj: { __component?: string }): obj is InternHeadline {
  return obj.__component === 'intern.headline';
}
